import { useCallback, useEffect, useState } from 'react';

export const useShippingInformation = ({ leadType }: { leadType: 'DAY' | 'WEEK' }) => {
  const [type, setType] = useState<string>(leadType);

  const handleTypeChange = useCallback((type: string) => {
    setType(type);
  }, []);
  useEffect(() => {
    setType(leadType);
  }, [leadType]);
  return {
    type,
    handleTypeChange,
  };
};
